import React from 'react';

const Card = ({
  title,
  children,
  actions,
  className = '',
  headerClassName = '',
  bodyClassName = '', 
  compact = false,
  allowOverflow = false,
  noBottomPadding = false,
  onClick,
}) => {
  return (
    <div 
      className={`bg-white rounded-lg shadow-sm ${allowOverflow ? '' : 'overflow-hidden'} self-start ${className}`}
      onClick={onClick}
    >
      {(title || actions) && (
        <div className={`${compact ? 'px-3 py-2' : 'px-4 py-3'} bg-gray-50 border-b border-gray-200 flex justify-between items-center ${headerClassName}`}>
          {title && <h3 className={`${compact ? 'text-base' : 'text-lg'} font-semibold text-gray-900`}>{title}</h3>}
          {actions && <div className="flex gap-2">{actions}</div>}
        </div>
      )}
      <div className={`${compact ? 'p-2' : noBottomPadding ? 'px-3 pt-3 pb-0' : 'p-3'} flex flex-col h-full min-h-0 ${bodyClassName}`}>{children}</div>
    </div>
  );
};

export default Card;
